import { CheckBadgeIcon } from '@heroicons/react/24/outline'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function CtaLogoCloud() {
  const navigate = useNavigate()
  return (
    <div>
        <div className='flex flex-col md:flex-row max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto'>
           
            <div className='md:w-1/2'>
            <img src="/logo-cloud.png" alt="Bild mit verschiedenen Logos wie Immoscout24 und Kleinanzeigen" />
            </div>
            <div className='md:w-1/2 mt-10 md:mt-0'>
                <h2 className='text-xl md:text-2xl font-serif  font-semibold text-prime-950 pb-2'>Ihr direkter Zugang zu Kaufinteressenten</h2>
                <div className='mt-4'>
                <div className='text-lg flex gap-5 '><CheckBadgeIcon className='size-6 md:size-8 shrink-0 fill-prime-100 inline'/><p className="text-dark-200">Wir präsentieren Ihr Objekt auf allen großen Online-Portalen und über soziale Medien.</p> </div>

                </div>
                <div className='mt-4'>
                <div className='text-lg flex gap-5 '><CheckBadgeIcon className='size-6 md:size-8 shrink-0 fill-prime-100 inline'/><p className="text-dark-200">Außerdem erhalten Sie Zugang zu unserem umfangreichen Käufernetzwerk - auf Wunsch diskret</p> </div>

                </div>
                <p className='text-prime-950 text-lg mt-6'>So erreichen wir regelmäßig bis zu 10.000 potenzielle Interessenten. Auf Wunsch vermarkten wir auch diskret über unseren exklusiven Käuferkreis, ganz ohne öffentliche Inserate.</p>
                <button onClick={()=>navigate("/bewerten/formular/online-bewertung")} className='bg-prime-100 hover:bg-prime-200 transition-all  text-prime-950 mt-8 p-4 rounded-lg text-lg font-medium'>Jetzt Käufer finden</button>
            </div>
            
        </div>
    </div>
  )
}
